// dependecies import ==>
import React, { useState, useRef, useEffect } from "react";
import swal from "sweetalert";
import moment from "moment";
import Popover from "react-popover";
// assets and scss import ==>
import "./myTransactionsTable.scss";
import raisedInvoice from "../../../../assets/raised-invoice.svg";
import info_icon from "../../../../assets/dashboard/info_icon.svg";
import NoDataFound from "../../../../assets/Nodata.svg";
// project file import ==>
import TitleValueComponent from "../../../common/Modules/TitleValueComponent";
import DocumentContainer from "../../../UI Component/DocumentViewer/DocumentCotainer";
import TitleSubtitleCard from "../../../common/Modules/TitleSubtitleCard";
// constant import ==>
import { HEADER_LIST, TRANSACTIONS_TABLE_HEADER_LIST } from "../../constants";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { formatDecimalNumber } from "../../../../Util/Helper/formatNumberWithDecimals";

const MyTransactionsTable = (props) => {
  const { userType, popoverClose, doctorRole, transactionsData, loader } =
    props;
  const [popoverId, setPopoverId] = useState(-1);
  // ccc

  const popoverRefs = useRef([]);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);

  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Invoice for Your Connect2Clinic appointment",
    fileType: ".pdf",
  });
  const [documentShow, setDocumentShow] = useState(false);

  // LifeCycle methods

  useEffect(() => {
    handlePopoverClose();
  }, [popoverClose]);

  // Actions ===>

  const closeNotification = () => {
    setDocumentShow(false);
    setFileDetails({
      fileURL: "",
      fileName: "Invoice for Your Connect2Clinic appointment",
      fileType: ".pdf",
    });
  };

  // <===

  // Api Calls ===>

  const handleViewReceipt = (appnt) => {
    setFileDetails({
      ...fileDetails,
      fileURL: appnt?.receipt,
    });
    if (appnt?.receipt !== "") {
      setDocumentShow(true);
    } else {
      swal({
        title: "Unable to generate receipt.",
        text: "Please try again",
        icon: "error",
        button: "Okay",
      });
      setDocumentShow(false);
    }
  };

  // handlers
  const handlePopoverOpen = (id) => {
    if (popoverRefs.current[id]) {
      popoverRefs.current[id].focus();
    }
    setPopoverId(popoverId !== id ? id : -1);
  };

  const handlePopoverClose = () => {
    setPopoverId(-1);
  };

  // Create UI ===>
  const displayHoverContent = (hoverText, ind) => {
    return (
      <div
        style={{ padding: "6px 10px", fontSize: "12px" }}
        onBlur={() => {
          handlePopoverClose();
        }}
        tabIndex={-1}
        ref={(el) => (popoverRefs.current[ind] = el)}
      >
        {hoverText}
      </div>
    );
  };

  const displayCellDataWithPopover = (value, hoverText, ind) => {
    return (
      <div className="title-value-container" key={ind}>
        <span className="value-text">{value}</span>
        <Popover
          isOpen={ind === popoverId}
          preferPlace={`below`}
          body={displayHoverContent(hoverText, ind)}
        >
          <img
            src={info_icon}
            alt=""
            style={{ cursor: "pointer", marginLeft: "6px" }}
            onClick={(e) => {
              e.stopPropagation();
              handlePopoverOpen(ind);
            }}
          />
        </Popover>
      </div>
    );
  };
  const displayMyTransactionsTable = () => {
    let headerList = TRANSACTIONS_TABLE_HEADER_LIST.filter(
      (list) =>
        list.applicableRoles.indexOf(userType) !== -1 ||
        list.applicableRoles.indexOf(doctorRole) !== -1
    );
    let arr = headerList.map((item) => {
      return item["title"];
    });
    return (
      <>
        <div className="mtt-table-container">
          {window.innerWidth > 767 && (
            <div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    {headerList.map((item) => (
                      <th key={item.id}>{item.title}</th>
                    ))}
                  </tr>
                </thead>
                {transactionsData?.length > 0 && (
                  <tbody>
                    {transactionsData.map((appnt, ind) => (
                      <tr key={ind}>
                        <td
                          className={
                            "mtt-table-patient-information-container " +
                            (clinicId
                              ? "mtt-table-patient-information-clinic"
                              : "")
                          }
                        >
                          {displayPatientInformation(appnt)}
                        </td>
                        {arr.includes(HEADER_LIST.DOCTOR_NAME) && (
                          <td className="mtt-table-doctor-name">
                            {appnt.doctor_name}
                          </td>
                        )}
                        <td className="mtt-table-procedures">
                          {displayProcedures(appnt)}
                        </td>
                        <td className="mtt-table-payment-method">
                          {getPaymentMethod(appnt)}
                        </td>
                        <td className="mtt-table-payment-status">
                          {appnt.payment_status}
                        </td>
                        <td className="mtt-table-paid-amount">
                          {displayPaidAmount(appnt)}
                        </td>
                        <td className="mtt-table-pending-fees">
                          {appnt.pending_fees
                            ? "₹" + formatDecimalNumber(appnt.pending_fees)
                            : "-"}
                        </td>
                        <td className="mtt-table-total-amount">
                          {displayTotalAmount(appnt, ind)}
                        </td>
                        <td className="mtt-table-total-amount">
                          {appnt?.receipt_no ? appnt?.receipt_no : "-"}
                        </td>

                        <td className="mtt-table-receipt">
                          {getReceiptUI(appnt)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
              {transactionsData?.length === 0 && (
                <div className="mtt-table-no-data">{displayNoDataFound()}</div>
              )}
            </div>
          )}
        </div>
      </>
    );
  };

  const displayMyTransactionsTableMobileView = () => {
    let headerList = TRANSACTIONS_TABLE_HEADER_LIST.filter(
      (list) =>
        list.applicableRoles.indexOf(userType) !== -1 ||
        list.applicableRoles.indexOf(doctorRole) !== -1
    );
    let arr = headerList.map((item) => {
      return item["title"];
    });

    return (
      <div className="mtt-table-container-mobile-view">
        {transactionsData?.length > 0
          ? transactionsData.map((appnt, ind) => (
              <span key={ind} className="mtt-table-mobile-view">
                <span className="mtt-table-mobile-view-data mtt-table-mobile-view-patient-information">
                  <TitleSubtitleCard
                    title={HEADER_LIST.PATIENT_INFORMATION}
                    subtitle={displayPatientInformation(appnt)}
                  />
                </span>
                {arr.includes(HEADER_LIST.DOCTOR_NAME) && (
                  <span className="mtt-table-mobile-view-data">
                    <TitleSubtitleCard
                      title={HEADER_LIST.DOCTOR_NAME}
                      subtitle={appnt.doctor_name}
                    />
                  </span>
                )}
                <span className="mtt-table-mobile-view-data mtt-table-payment-method">
                  <TitleSubtitleCard
                    title={HEADER_LIST.PAYMENT_METHOD}
                    subtitle={getPaymentMethod(appnt)}
                  />
                </span>
                <span className="mtt-table-mobile-view-data">
                  <TitleSubtitleCard
                    title={HEADER_LIST.PROCEDURE}
                    subtitle={displayProcedures(appnt)}
                  />
                </span>
                <span className="mtt-table-mobile-view-data">
                  <TitleSubtitleCard
                    title={HEADER_LIST.STATUS}
                    subtitle={appnt.payment_status}
                  />
                </span>
                <span className="mtt-table-mobile-view-data">
                  <TitleSubtitleCard
                    title={HEADER_LIST.PENDING}
                    subtitle={
                      appnt.pending_fees
                        ? "₹" + formatDecimalNumber(appnt.pending_fees)
                        : "-"
                    }
                  />
                </span>
                <span className="mtt-table-mobile-view-data">
                  <TitleSubtitleCard
                    title={HEADER_LIST.PAID}
                    subtitle={displayPaidAmount(appnt)}
                  />
                </span>
                <span className="mtt-table-mobile-view-data">
                  <TitleSubtitleCard
                    title={HEADER_LIST.AMOUNT}
                    subtitle={displayTotalAmount(appnt)}
                  />
                </span>
                <span className="mtt-table-mobile-view-data">
                  <TitleSubtitleCard
                    title={HEADER_LIST.RECEPIT_NO}
                    subtitle={appnt.receipt_no ? appnt.receipt_no : "-"}
                  />
                </span>
                <span className="mtt-table-mobile-view-data">
                  <TitleSubtitleCard
                    title={HEADER_LIST.RECEIPT}
                    subtitle={getReceiptUI(appnt)}
                  />
                </span>
              </span>
            ))
          : displayNoDataFound()}
      </div>
    );
  };

  const displayPatientInformation = (appnt) => {
    return (
      <span className="mtt-table-patient-information">
        <span className="mtt-table-patient-name">{appnt.patient_name}</span>
        {getUHID(appnt)}
        {getPatientPhoneNo(appnt)}
      </span>
    );
  };

  const getUHID = (appnt) => {
    return (
      <>
        {appnt?.formatted_uhid && (
          <span className="mtt-table-uhid">UHID: {appnt.formatted_uhid}</span>
        )}
      </>
    );
  };

  const getPatientPhoneNo = (appnt) => {
    return (
      <span style={{ marginTop: "4px" }}>
        {appnt.patient_phone_no}
        {" | "}
        {moment(appnt.appointment_date).format("DD/M/YY")}
      </span>
    );
  };

  const displayProcedures = (appnt) => {
    return (
      <>
        {appnt.group_procedures?.length > 1 ? (
          <TitleValueComponent
            value={appnt.group_procedures
              .filter((ele, ind) => ind < 2)
              .map((item) => item)
              .join(", ")}
            customTextToHover={
              appnt.group_procedures?.length - 2 > 0 && (
                <span className="mtt-table-multiple-modes-text">
                  {"+" + (appnt.group_procedures?.length - 2)}
                </span>
              )
            }
            hoverText={
              appnt.group_procedures?.length - 2 > 0 &&
              displayMultipleProcedures(appnt)
            }
          />
        ) : (
          <>{appnt.group_procedures[0]}</>
        )}
      </>
    );
  };

  const displayMultipleProcedures = (appnt) => {
    return (
      <span>
        {appnt.group_procedures.map(
          (item, ind) => ind !== 0 && ind !== 1 && <li key={ind}>{item}</li>
        )}
      </span>
    );
  };

  const getPaymentMethod = (appnt) => {
    return (
      <>
        {appnt.payment_mode?.includes("Multiple") ? (
          <TitleValueComponent
            value="Multiple"
            customTextToHover={
              <span className="mtt-table-multiple-modes-text">
                {"+" + appnt.multiple_payment_modes?.length}
              </span>
            }
            hoverText={displayMultiplePaymentModes(appnt)}
          />
        ) : (
          appnt.payment_method
        )}
      </>
    );
  };

  const displayMultiplePaymentModes = (appnt) => {
    return (
      <span>
        {appnt.multiple_payment_modes.map((item, ind) => (
          <li key={ind}>{item}</li>
        ))}
      </span>
    );
  };

  const displayPaidAmount = (appnt) => {
    return (
      <span>
        {appnt.paid_amount ? (
          <TitleValueComponent
            value={"₹" + formatDecimalNumber(appnt.paid_amount)}
            icon={+appnt.partial_amount > 0 ? info_icon : null}
            hoverText={
              +appnt.partial_amount > 0 ? getPartialAmountUI(appnt) : ""
            }
          />
        ) : (
          "-"
        )}
      </span>
    );
  };

  const getPartialAmountUI = (appnt) => {
    return (
      <>
        {"Partial fee "}
        <b>{"₹" + formatDecimalNumber(appnt.partial_amount)}</b>
      </>
    );
  };

  const displayTotalAmount = (appnt, ind) => {
    return (
      <span>
        {displayCellDataWithPopover(
          "₹" + formatDecimalNumber(appnt.total_amount),
          getTransactionIdsOnHover(appnt),
          ind
        )}
      </span>
    );
  };

  const getTransactionIdsOnHover = (appnt) => {
    let transactionIds = { ...appnt?.transaction_ids };

    return (
      <div className="transaction-id-popup">
        {transactionIds?.online && (
          <div style={{ marginBottom: "8px" }}>
            {getTranactionTypeChip("Online")}
            {getOnlineTransactionStatus(transactionIds)}
            {getClinicTransactionIdList(transactionIds?.online)}
          </div>
        )}
        {transactionIds?.inclinic && (
          <div>
            {getTranactionTypeChip("In-Clinic")}
            {getClinicTransactionIdList(transactionIds?.inclinic)}
          </div>
        )}
      </div>
    );
  };

  const getClinicTransactionIdList = (transactionIdList) => {
    let filteredList = transactionIdList?.filter(
      (transaction) => transaction?.trim() !== ""
    );
    return (
      <>
        {filteredList?.length > 0 ? (
          <div>
            {filteredList?.map((apt, index) => (
              <span key={index} style={{ marginBottom: "5px" }}>
                {getClinicTransactionIDs(
                  apt,
                  filteredList?.length > 1 ? index + 1 : ""
                )}
              </span>
            ))}
          </div>
        ) : (
          <div className="mtt-transaction-id">{"Transaction ID : -"}</div>
        )}
      </>
    );
  };

  const getClinicTransactionIDs = (apt, index) => {
    return (
      <div className="mtt-transaction-id">
        {`Transaction ID ${index ? index : ""} : `}
        <span style={{ wordBreak: "break-all" }}>{apt}</span>
      </div>
    );
  };

  const getTranactionTypeChip = (type) => {
    return (
      <div
        className={
          "mtt-transaction-type-chip " +
          (type?.toLowerCase() === "online" ? "mtt-online-chip" : "")
        }
      >
        {type}
      </div>
    );
  };

  const getOnlineTransactionStatus = (transactionIds) => {
    return (
      <span className="mtt-transaction-status">
        Status:{" "}
        <span
          className={
            "mtt-online-status " +
            (transactionIds?.online?.length === 0
              ? "mtt-online-status-not-settled"
              : "")
          }
        >
          {transactionIds?.online?.length > 0
            ? "Settled"
            : "Settlement Pending"}
        </span>
      </span>
    );
  };

  const getReceiptUI = (appnt) => {
    return (
      <>
        {appnt.receipt ? (
          <span className="mtt-table-receipt-ui">
            <span style={{ display: "table" }}>
              <span
                className="mtt-table-receipt-view-btn"
                onClick={() => handleViewReceipt(appnt)}
              >
                <span className="mtt-table-receipt-view-text">View</span>{" "}
                <img alt="" src={raisedInvoice} />
              </span>
            </span>
            {appnt.invoice_raised_time &&
              appnt.invoice_raised_by &&
              appnt.invoice_raised_time !== "-" &&
              appnt.invoice_raised_by !== "-" && (
                <span>
                  <TitleValueComponent
                    title=""
                    value={`Invoice ${moment(appnt.invoice_raised_time).format(
                      "MMM DD, YYYY"
                    )}`}
                    icon={info_icon}
                    hoverText={appnt.invoice_raised_by}
                  />
                </span>
              )}
          </span>
        ) : (
          "-"
        )}
      </>
    );
  };

  const displayNoDataFound = () => {
    return (
      !loader && (
        <div className="no-data-found">
          <div className="">
            <img src={NoDataFound} alt="noData" />
          </div>
          <div style={{ marginTop: 15 }}>
            <span
              style={{
                fontWeight: "bold",
                fontSize: 15,
                color: "#1B2027",
                textAlign: "center",
              }}
            >
              No Record Found
            </span>
          </div>
          <span style={{ fontSize: 12, color: "#707070", textAlign: "center" }}>
            There are no appointments available
          </span>
        </div>
      )
    );
  };

  // <===

  return (
    <div className="mytransactions-table-container">
      {documentShow && (
        <DocumentContainer
          cancelHandler={() => closeNotification()}
          url={fileDetails.fileURL}
          fileName={fileDetails.fileName}
          fileType={fileDetails.fileType}
          width={"98%"}
        />
      )}
      {window.innerWidth > 768
        ? displayMyTransactionsTable()
        : displayMyTransactionsTableMobileView()}
    </div>
  );
};

export default MyTransactionsTable;
